<advanced-filter (onSubmit)="applyFilter()" *ngIf="isCoLogin()"></advanced-filter>
<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<wl-card heading="{{heading}} ({{totalCount}})" subheading1="{{subheading1}}" subheading2="{{subheading2}}" *ngIf="showConsentDataTable">

    <!-- <input type="month" id="start" name="start"
    min="2022-01" [max]="maxDate" [(ngModel)]="currentDate" #date1
    style="
    height: 35px;
      border-color: rgb(223, 223, 223);
      box-shadow: 0 2px 3px 0 rgba(179, 179, 179, 0.2), 0 3px rgba(177, 177, 177, 0.19);
      border-radius: 4px;
      border-left: 0px solid rgb(223, 223, 223);
      border-right: 0px solid rgb(223, 223, 223); 
      border-top: 1px solid rgb(236, 236, 236); 
      border-bottom: 0px solid rgb(223, 223, 223);
    ">
    <input type="month" id="end" name="ends"
    min="2022-01" [max]="maxDate" [(ngModel)]="currentDate" #date2 class="display-none"> -->

    <wl-date-input (dateRangeSelected)="onDateRangeSelected($event)" *ngIf="!isCoLogin()"></wl-date-input>

    <!-- <button class="ml-10px mybutton" (click)="submitDates()">Submit</button> -->

    <span *ngIf="showSelectedDate && !isCoLogin()" class="datetext">&nbsp;&nbsp;{{selectedDate}}&nbsp;&nbsp;

      <img src="../../../assets/fontawesome-web/svgs/regular/rectangle-xmark.svg" class="h-15px" (click)="closeButtonClick()">
  </span>


  <div class="flex-between align-start" *ngIf="iscredCount; else elseBlock">
  </div>

  <ng-template #elseBlock>
    <div class="float-left">
      <button class="mybutton" *ngIf="!reportLink" (click)="getLogReport()">View Log Report</button>
    </div>
  </ng-template>


  <wl-search-input (searchValueChanged)="onSearch($event)" [ngClass]="{'search': isCoLogin()}"></wl-search-input>
  <br>

  <p *ngIf="noUserFound" class="m-100px text-center font-size-15em">{{noUserFound}}</p>

  <div *ngIf="!noUserFound" child-container class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>CIF ID</th>
          <th>Name</th>
          <th>Acc. No.</th>
          <th *ngIf="showFilter1 || showFilter2">Sanctioned Date</th>
          <th *ngIf="showFilter3">Sanctioned<br>Limit</th>
          <th>Due date <br> of Renewal</th>
          <th *ngIf="makerOnly && showPending" class="ml-20px">&nbsp;&nbsp;&nbsp;Send SMS</th>
          <!-- <th class="text-center">Co-Applicants</th> -->
          <th *ngIf="showFilter1" class="text-center">Consent Date</th>
          <th *ngIf="showFilter1 || showFilter2 || showFilter3" class="text-center">Actions</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let user of allUsers;let i = index;">



          <td class="vertical-align-middle">{{10 *(pageId-1)+i+1}}</td>

          <td class="vertical-align-middle">{{user.custId}}</td>
          <td class="vertical-align-middle w-16pct">{{user.profile.name}}</td>
          <td class="vertical-align-middle">{{user?.user_docs?.kcc_acc_no_unMasked}}</td>
          <td *ngIf="showFilter1 || showFilter2" class="vertical-align-middle">{{user?.user_docs?.date_of_sanction}}</td>
          <td *ngIf="showFilter3" class="vertical-align-middle">{{user?.user_docs?.existing_loan_details.existing_limit}}</td>
          <td><p>{{user?.user_docs?.renewal_duedate_for_credit_limit}}</p></td>
          <td *ngIf="makerOnly && showPending">
            <wl-button-nolabel (click)="sendSms(user.id)">SMS</wl-button-nolabel>

          </td>

          <!-- <td *ngIf="showOrHide;  else elseBlock" class="text-center p-4px">

            <a color="primary" [routerLink]="['../view-coapplicants/', user.custId]"
              (click)="retailCheck(user.isRetail)">
              <i class="ml-5px text-black"><img src="../../../assets/svg/view.svg"></i>
            </a>
          </td> -->


          <ng-template #elseBlock>
            <td class="vertical-align-middle p-4px">

              <a class="text-no-decoration" color="primary"
                [routerLink]="['../view-coapplicants', user.custId]" (click)="retailCheck(user.isRetail)">
                <i class="ml-30px text-black"><img src="../../../assets/svg/view.svg"></i>
              </a>
            </td>
          </ng-template>

          <ng-template #elseBlock1>
            <td class="vertical-align-middle p-4px">

              <a class="text-no-decoration" color="primary"
                [routerLink]="['../view-guarantor', user.custId ]">
                <i class="ml-30px text-black"><img src="../../../assets/svg/view.svg"></i>
              </a>
            </td>
          </ng-template>

          <td class="text-center" *ngIf="showFilter1" >
            <p>{{get_consent_approval_date(i)}}</p>
          </td>

          <td class="text-center pt-20px" *ngIf="showFilter1 || showFilter2 || showFilter3">
            <a class="text-no-decoration cursor-pointer" color="primary" target="_blank" color="primary" (click)="View(user.id)">
              Consent Form <span *ngIf="showFilter2 || showFilter3">| </span>
            </a><span class="text-no-decoration cursor-pointer" color="primary" target="_blank" color="primary" (click)="sendSms(user.id)" *ngIf="showFilter2 || showFilter3"><a>Send SMS</a></span>
          </td>


        </tr>
      </tbody>
    </table>
  </div>

  <nav class="flex-center" *ngIf="totalPage>1" aria-label="Page navigation example">
    <ul class="pagination">

      <li *ngIf="page>3"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">Previous</a></li>
      <li *ngIf="page>2"><a (click)="getAllUsersPage(filter,roleId,offset - 20,10,page - 2)">{{page - 2}}</a></li>
      <li *ngIf="page>1"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">{{page - 1}}</a></li>
      <li class="page-item active"><a (click)="getAllUsersPage(filter,roleId,offset,10,page)">{{page}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">{{page + 1}}</a></li>
      <li *ngIf="page+1<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 20,10,page + 2)">{{page + 2}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">Next</a></li>
    </ul>
  </nav>


</wl-card>





<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
  integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous" />
<!-- <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css"> -->